import { Modal, Form, Tooltip } from 'antd';
import React, { useState, useEffect } from 'react';
import { salvarComentarioAnexo } from '@app/api/demanda';
import { Button, Icon } from '@digital/ui';
import ListMensagem from './ListMensagem';
import TextArea from 'antd/lib/input/TextArea';

export interface PropsModalComentario {
  anexoId: string;
  contemComentario: boolean;
  preSuprimentos: boolean | undefined;
}

const ModalComentariosAnexoDemanda = (props: PropsModalComentario) => {
  const { anexoId, contemComentario, preSuprimentos } = props;
  const [recarregarMensagem, setRecarregarMensagem] = useState(false);
  const [exibirModal, setExibirModal] = useState(false);
  const [iconeComentario, setIconeComentario] = useState('');
  const textAreaId = `textAreaId${anexoId}`;

  useEffect(() => {
    if (contemComentario === true) {
      MudarIconeAnexo();
    }
  }, [contemComentario]);

  const MudarIconeAnexo = () => {
    setIconeComentario('has-comments');
  };

  const limparCampo = () => {
    const elemento = document.getElementById(textAreaId);
    if (elemento != null) {
      document.getElementById(textAreaId).value = '';
    }
  };

  const getAll = async () => {
    setRecarregarMensagem(!recarregarMensagem);
  };

  const showModal = () => {
    limparCampo();
    setExibirModal(true);
  };

  const handleCancel = () => {
    limparCampo();
    setExibirModal(false);
  };

  const Salvar = (e: any) => {
    const text = document.getElementById(textAreaId).value;
    const form = new FormData();
    form.append('anexoId', anexoId);
    form.append('mensagem', text);
    form.append('preSuprimentos', preSuprimentos ? '1' : '0');

    salvarComentarioAnexo(form).then(data => {
      if (data.valid) {
        limparCampo();
        setRecarregarMensagem(!recarregarMensagem);
        MudarIconeAnexo();
      }
    });
  };

  return (
    <>
      <Tooltip title="Comentários">
        <Button
          onClick={() => {
            getAll();
            showModal();
          }}
          icon="messaging-comments"
          className={iconeComentario}
        />
      </Tooltip>
      <Modal
        title="Comentário"
        className="chat-modal"
        visible={exibirModal}
        onCancel={() => {
          handleCancel();
        }}
        footer={[
          <Button type="link" onClick={() => handleCancel()}>
            Fechar
          </Button>,
          <Button key="submit" type="primary" onClick={e => Salvar(e)}>
            Enviar
          </Button>,
        ]}>
        {anexoId && <ListMensagem anexoId={anexoId} recarregarMensagem={recarregarMensagem} />}
        <div className="chat-modal-message-box">
          <Form>
            <Form.Item>
              <TextArea id={textAreaId} placeholder="mensagem" autosize={{ minRows: 3, maxRows: 5 }} maxLength={300}/>
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </>
  );
};

export default ModalComentariosAnexoDemanda;
